@switch (state) {
  @case ("loading") {
    <span class="d">
      <span class="bk-sr-only">Loading delivery</span>
      <span class="bk-skel d__skel-line" aria-hidden="true"></span>
      <span class="bk-skel d__skel-bar" aria-hidden="true"></span>
    </span>
  }
  @case ("ready") {
    @if (summary.total === 0) {
      <span class="d__none" title="No delivery receipts have come back for this send yet">
        No receipts yet
      </span>
    } @else {
      <!-- The verdict shows; screen readers get the full breakdown instead. -->
      <span class="d" [attr.data-verdict]="verdict" [attr.title]="breakdown">
        <span class="d__verdict" aria-hidden="true">{{ verdictLabel }}</span>
        <span class="bk-sr-only">{{ verdictLabel }}: {{ breakdown }}</span>
        <span class="d__detail" aria-hidden="true">
          <span class="d__bar">
            <span class="d__seg d__seg--ok" [style.flex-grow]="summary.delivered"></span>
            @if (summary.failed) {
              <span class="d__seg d__seg--bad" [style.flex-grow]="summary.failed"></span>
            }
            <span class="d__seg d__seg--wait" [style.flex-grow]="summary.inFlight"></span>
          </span>
          <span class="d__count">{{ formatCount(summary.delivered) }} / {{ formatCount(summary.total) }}</span>
        </span>
      </span>
    }
  }
  @case ("error") {
    <span class="d__none" title="Delivery receipts could not be loaded">
      <span aria-hidden="true">—</span>
      <span class="bk-sr-only">Delivery receipts could not be loaded</span>
    </span>
  }
  @default {
    <span class="d__none" title="Delivery shows once the message is sent">
      <span aria-hidden="true">—</span>
      <span class="bk-sr-only">Not sent yet</span>
    </span>
  }
}
